module.exports = __webpack_public_path__ + "static/media/Bean Eater-1s-84px.b62edb50.svg";